"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.password.placeholder': '输入密码',
};
